'use client'

import { useEffect } from 'react'
// react-scan must be imported before react
import { scan } from 'react-scan'

export const ReactScan = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && process.env.NEXT_PUBLIC_SCAN === 'true') scan({})
  }, [])

  return <></>
}
